import { DialogBody } from "@blueprintjs/core";
import Image from "next/image";
import styles from './wrapup.module.css';

export default function WrapupModuleFinaleComponent(): React.ReactNode {
    return <DialogBody className={styles.dialogBody}>
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <h1>That&apos;s it!</h1>
            <Image src='/images/emojis/gg.png' width={256} height={256} alt='victory' />
            <h3>
                Thank you so much for being a part of our community! We look forward to meeting you on the fields of battle next year. Memento mori!
            </h3>
        </div>
    </DialogBody>
}
